import React from 'react';
import { heroTestimonials } from '../data/content';
export function HeroTestimonials() {
  return <section className="w-full bg-ink-800 px-4 py-8 sm:px-6 sm:py-12" data-id="element-94" data-mp="12rnp3k4pw8rd">
      <div className="mx-auto max-w-5xl" data-id="element-95" data-mp="y17cg28q0r62">
        <h2 className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-neutral-400 sm:text-xs" data-id="element-96" data-mp="y05pp0iceg8i">
          Lo que dicen los que ya lo tienen
        </h2>

        <ul className="mt-5 grid gap-3 md:grid-cols-3" data-id="element-97" data-mp="p1251s3j1srw">
          {heroTestimonials.map(item => <li key={item.initials} data-id="element-98" data-mp="k0whan0doqf3">
              <figure className="flex h-full flex-col rounded-xl border border-white/10 bg-ink-700 p-4" data-id="element-99" data-mp="jzuytxh191nc">
                <div className="flex items-center gap-2.5" data-id="element-100" data-mp="f2mmwemh9tuj">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold-500 text-xs font-extrabold text-ink-900" data-id="element-101" data-mp="b1jak23n2fy2">
                    {item.initials}
                  </span>
                  <span className="text-xs text-gold-400" data-id="element-102" data-mp="25ftz09gbn83b">★★★★★</span>
                </div>
                <blockquote className="mt-3 text-[13px] leading-relaxed text-neutral-300" data-id="element-103" data-mp="2ml3hq425u2ci">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-auto pt-3 text-xs font-bold text-gold-500" data-id="element-104" data-mp="2ri3flrouvysj">
                  {item.author}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}